<template>
  <div class="sqlb">
    <div class="gmsqlb">
      <div class="headershenqing">
        <div class="headershenqinginside">
          <el-form
            :model="formInline"
            class="demo-form-inline"
            style="display: flex; height: 39px"
            label-width="90px"
            label-position="left"
          >
            <el-form-item label="证件编号:" required>
              <el-input
                v-model="formInline.bianhao"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="证件类型:" required>
              <el-select
                v-model="formInline.type"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <el-button
              type="primary"
              icon="el-icon-search"
              @click="search"
            >搜索
            </el-button>
          </el-form>
        </div>
      </div>
      <div class="tableGMZ">
        <div v-show="zjType !== 2">
          <h3 style="color: #8f9298;margin-left: 10px">购买证报备</h3>
          <div>
            <h4 style="color: #8f9298;margin-left: 5%">本证购买报备</h4>
          </div>
          <div id="gmbbTable" class="bbTable" style="width: 90%;margin-left: 5%">
            <el-table
              border
              :data="bzgmbbData.gmbbDtos"
              :summary-method="gmtotal"
              show-summary
              style="width: 100%; margin-bottom: 22px"
            >
              <el-table-column min-width="10%" show-overflow-tooltip prop="yszBh" label="运输证编号" />
              <el-table-column min-width="20%" show-overflow-tooltip prop="gmdwMc" label="购买单位" />
              <el-table-column min-width="20%" show-overflow-tooltip prop="xsdwMc" label="销售单位" />
              <el-table-column min-width="10%" show-overflow-tooltip label="入库数量">
                <template v-slot="scope">
                  {{ scope.row.rksl }}{{ scope.row.rkslDw }}
                </template>
              </el-table-column>
              <el-table-column min-width="10%" show-overflow-tooltip prop="rkrq" label="入库日期" />
              <el-table-column min-width="10%" show-overflow-tooltip prop="djsj" label="登记时间" />
              <el-table-column min-width="15%" show-overflow-tooltip prop="rkbh" label="入库编号" />
              <el-table-column min-width="10%" show-overflow-tooltip prop="ckmc" label="仓库名称" />
              <el-table-column min-width="15%" show-overflow-tooltip label="仓库所在地">
                <template v-slot="scope">
                  {{ scope.row.provinceLabel }}{{ scope.row.cityLabel }}{{ scope.row.countyLabel }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <h4 style="color: #8f9298;margin-left: 5%">本证销售报备</h4>
          </div>
          <div id="xsbbTable" class="bbTable" style="width: 90%;margin-left: 5%">
            <el-table
              border
              :data="bzxsbbData.xsbbList"
              :summary-method="xstotal"
              show-summary
              style="width: 100%"
            >
              <el-table-column min-width="10%" show-overflow-tooltip prop="yszBh" label="运输证编号" />
              <el-table-column min-width="20%" show-overflow-tooltip prop="gmdwMc" label="购买单位" />
              <el-table-column min-width="20%" show-overflow-tooltip prop="xsdwMc" label="销售单位" />
              <el-table-column min-width="10%" show-overflow-tooltip label="出库数量">
                <template v-slot="scope">
                  {{ scope.row.cksl }}{{ scope.row.ckslDw }}
                </template>
              </el-table-column>
              <el-table-column min-width="10%" show-overflow-tooltip prop="ckrq" label="出库日期" />
              <el-table-column min-width="10%" show-overflow-tooltip prop="djsj" label="登记时间" />
              <el-table-column min-width="15%" show-overflow-tooltip prop="ckbh" label="出库编号" />
              <el-table-column min-width="10%" show-overflow-tooltip prop="ckmc" label="仓库名称" />
              <el-table-column min-width="15%" show-overflow-tooltip label="仓库所在地">
                <template v-slot="scope">
                  {{ scope.row.provinceLabel }}{{ scope.row.cityLabel }}{{ scope.row.countyLabel }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-show="zjType !== 1">
          <h3 style="color: #8f9298;margin-left: 10px">运输证报备</h3>
          <div>
            <h4 style="color: #8f9298;margin-left: 5%">本证运输报备</h4>
          </div>
          <div id="ysbbTable" class="bbTable" style="width: 90%;margin-left: 5%">
            <el-table
              border
              :data="bzysbbData.xsbbList"
              :summary-method="ystotal"
              show-summary
              style="width: 100%"
            >
              <el-table-column min-width="15%" show-overflow-tooltip prop="gmzBh" label="购买证编号" />
              <el-table-column min-width="30%" show-overflow-tooltip prop="bbdw" label="单位名称" />
              <el-table-column min-width="10%" show-overflow-tooltip label="运输数量">
                <template v-slot="scope">
                  {{ scope.row.qysl }}{{ scope.row.qyslDw }}
                </template>
              </el-table-column>
              <el-table-column min-width="10%" show-overflow-tooltip prop="ysrq" label="运输日期" />
              <el-table-column min-width="15%" show-overflow-tooltip prop="djsj" label="登记时间" />
              <el-table-column min-width="20%" show-overflow-tooltip prop="bbbh" label="报备编号" />
            </el-table>
          </div>
        </div>
        <div>
          <h3 style="color: #8f9298;margin-left: 10px">证件图片</h3>
          <div class="bbTable" style="width: 90%;margin-left: 5%">
            <el-image
              :src="xkzImg.url"
              :preview-src-list="xkzImg.srcList"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 获取接口地址
import { getGmbb, getXsbb, getYsbb } from '@/assets/js/Bzgmxsys'
import {returnShowPicByPdf} from '@/assets/js/common'

export default {
  name: 'Bzgmxsys',
  data() {
    return {
      zjType: '0', // 当前证件类型，0初始化、1购买证、2运输证
      // 搜索条件
      formInline: {
        bianhao: '',
        type: ''
      },
      bzgmbbData: '', // 本证购买报备表格数据
      bzxsbbData: {
        xsbbList: []
      }, // 本证销售报备表格数据
      bzysbbData: {
        xsbbList: []
      }, // 本证运输报备表格数据
      options: [{
        value: '1',
        label: '购买证'
      }, {
        value: '2',
        label: '运输证'
      }],
      xkzImg: {
        url: '',
        srcList: []
      }
    }
  },
  created() {
  },
  methods: {
    // 点击搜索时
    search() {
      if (this.formInline.bianhao === '') {
        this.$message.error('证件编号不能为空')
        return
      }
      if (this.formInline.type === '') {
        this.$message.error('证件类型不能为空')
        return
      }
      let xkzLx = ''
      if (this.formInline.type === '1') { // 购买证
        this.zjType = 1
        getGmbb(this.formInline.bianhao).then((e) => {
          // 本证购买报备
          this.bzgmbbData = e.data.data
          getXsbb(this.formInline.bianhao).then((e) => {
            // 本证销售报备
            this.bzxsbbData = e.data.data
          })
        })
        this.bzysbbData.xsbbList = []
        // 获取证件照片
        xkzLx = 'G'
      } else { // 运输证
        this.zjType = 2
        getYsbb(this.formInline.bianhao).then((e) => {
          // 本证销售报备
          this.bzysbbData = e.data.data
        })
        this.bzgmbbData = ''
        this.bzxsbbData = ''
        // 获取证件照片
        xkzLx = 'Y'
      }
      const imgUrl = returnShowPicByPdf(this.formInline.bianhao)
      this.xkzImg.url = imgUrl
      this.xkzImg.srcList.push(imgUrl)
      /*getXkzImg(this.formInline.bianhao, xkzLx).then((e) => {
        const imgUrl = returnShowPic() + e.data.data
        this.xkzImg.url = imgUrl
        this.xkzImg.srcList.push(imgUrl)
      })*/
    },
    gmtotal() {
      const sums = []
      sums[0] = '入库数量合计'
      sums[1] = this.bzgmbbData.ckslhj + this.bzgmbbData.ckslhjdw
      sums[2] = '本证剩余数量'
      sums[3] = this.bzgmbbData.xkzsysl + this.bzgmbbData.xkzsysldw
      this.adjustment('gmbbTable')
      return sums
    },
    xstotal(param) {
      const sums = []
      sums[0] = '出库数量合计'
      sums[1] = this.bzxsbbData.ckslhj + this.bzxsbbData.ckslhjdw
      sums[2] = '本证剩余数量'
      sums[3] = this.bzxsbbData.xkzsysl + this.bzxsbbData.xkzsysldw
      this.adjustment('xsbbTable')
      return sums
    },
    ystotal(param) {
      const sums = []
      sums[0] = '出库数量合计'
      sums[1] = this.bzysbbData.ysslhj + this.bzysbbData.ysslhjdw
      sums[2] = '本证剩余数量'
      sums[3] = this.bzysbbData.xkzsysl + this.bzysbbData.xkzsysldw
      this.adjustment('ysbbTable')
      return sums
    },
    adjustment(bbid) {
      // 设置最后合计行合并
      const element = document.querySelector('#' + bbid + ' .el-table--border .el-table__footer tr td')

      if (element != null) {
        const childNodes = document.querySelector('#' + bbid + ' .el-table--border .el-table__footer tr').childNodes
        let i = 0
        for (const childNode of childNodes) {
          if (i === 0 || i === 2) {
            childNode.setAttribute('colspan', '3')
          }
          if (childNode.firstChild != null) {
            childNode.firstChild.style.cssText = 'white-space: nowrap;'
          }
          i += 1
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

.sqlb {
  margin: 0 auto;
  margin-top: 35px;

  .el-button--primary {
    color: #fff;
    background-color: #4170ff;
    border-color: #4170ff;
  }

  /deep/ .el-pagination__total {
    margin-left: 8px;
  }

  .el-pagination {
    padding: 10px 0;
    border: 1px solid #ebeef5;
    border-top: 0;
  }

  .gmsqlb {
    padding-bottom: 10px;
    margin: 0 auto;
    width: 95%;
    max-width: 1503px;

    .headershenqing {
      display: flex;
      align-items: center;
      margin: 0 auto;
      height: 96px;
      background-color: #fff;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      margin-bottom: 10px;

      .headershenqinginside {
        margin: 0 auto;
        width: 90%;

        /deep/ .el-button {
          height: 39px;
          border-radius: 20px;
        }

        /deep/ .el-form-item {
          margin-bottom: 10px;
          margin-right: 30px;
        }
      }
    }

    .tableGMZ {
      background-color: #fff;
      // margin: 21px auto 57px auto;
      .tableinside {
        width: 90%;
        margin: 0 auto;
        padding: 40px 0 57px;

        /deep/ .el-table {
          z-index: 0;
        }

        /deep/ .el-table .has-gutter tr th {
          background: #f4f4f4;
        }

        .addmessheader {
          background: #f4f4f4;

          .addmess {
            margin: 12px 0 12px 8px;
          }
        }
      }
    }

    .el-dialog {
      .el-dialog__footer {
        .el-button {
          margin: 0 20px;
        }
      }
    }
  }
}

/deep/ .has-gutter {
  .el-checkbox {
    display: none;
  }
}
</style>
<style>
/*改变边框颜色*/
.bbTable .el-table--border, .bbTable .el-table--group {
  border: 1px solid #2c2c2c !important;
}

/*改变表格内竖线颜色*/
.bbTable .el-table--border td, .bbTable .el-table--border th, .bbTable .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: 1px solid #260202 !important;
}

/*改变表格内行线颜色*/
.bbTable .el-table td, .bbTable .el-table th.is-leaf {
  border-bottom: 1px solid #180202 !important;
}

.bbTable .el-table__footer-wrapper tbody td {
  border-top: 1px solid #180202 !important;
}

.bbTable .el-table .cell {
  text-align: center;
}
</style>
